import { Device } from "@twilio/voice-sdk"

const TwilioDevice = {
  mounted() {
    const token = this.el.dataset.token
    const refreshTokenUrl = this.el.dataset.refreshTokenUrl
    this.activeCall = null
    this.callDurationInterval = null
    this.startedAt = null

    if (!token) {
      return
    }

    if (!refreshTokenUrl) {
      return
    }

    this.device = new Device(token, {
      logLevel: 2,
      closeProtection: true,
    })

    this.device.on("error", (error) => {
      this.reportClientError(error)
    })

    this.device.on("tokenWillExpire", () => {
      this.refreshToken(refreshTokenUrl)
    })

    this.handleEvent("twilio:call", (params) => {
      this.callID = params.call_id
      this.to = params.to
      this.from = params.from

      this.makeCall()
    })

    this.handleEvent("twilio:hangup", (params) => {
      this.device.disconnectAll()
    })

    this.handleEvent("twilio:digit", ({ digit }) => {
      if (this.activeCall) {
        this.activeCall.sendDigits(digit)
      }
    })
    this.handleEvent("twilio:in-progress", (params) => {
      this.startedAt = new Date()
      clearInterval(this.callDurationInterval)

      this.callDurationInterval = setInterval(() => {
        const durationEl = this.el.querySelector(".call-duration-target")
        if (durationEl) {
          durationEl.textContent = formatDuration(this.startedAt)
        }
      }, 500)
    })

    this.pushEventTo(this.el, "phone-dialing:init")
  },

  destroyed() {
    this.device?.destroy()
  },

  async makeCall() {
    try {
      this.startedAt = null

      this.activeCall = await this.device.connect({
        params: {
          From: this.from,
          To: this.to,
          EnaiaID: this.callID,
        },
      })

      this.activeCall.on("accept", (conn) => {
        this.pushEventTo(this.el, "phone-dialing:connected")
      })

      this.activeCall.on("disconnect", () => {
        this.pushEventTo(this.el, "phone-dialing:hungup", {
          duration: this.startedAt ? formatDuration(this.startedAt) : "00:00",
        })
        clearInterval(this.callDurationInterval)
      })

      this.activeCall.on("error", (error) => {
        this.reportClientError(error)
      })
    } catch (error) {
      this.reportClientError(error)
    }
  },

  async refreshToken(refreshTokenUrl) {
    try {
      const resp = await fetch(refreshTokenUrl)
      const { token: token } = await resp.json()

      this.device.updateToken(token)
    } catch (error) {
      this.reportClientError(error)
    }
  },

  reportClientError(error) {
    // Handle null/undefined errors safely
    const errorMsg = error
      ? error.message || String(error)
      : "Unknown connection error"
    this.pushEventTo(this.el, "phone-dialing:client-error", {
      message: errorMsg,
      from: this.from,
      to: this.to,
    })
  },
}

function formatDuration(start, end = new Date()) {
  const duration = end - start
  const minutes = Math.floor(duration / 60000)
  const seconds = Math.floor((duration % 60000) / 1000)

  // Format seconds with leading zeros to match backend format from CallHistory.format_call_duration/1
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
}

export { TwilioDevice }
